import { render, staticRenderFns } from "./NFCWriter.vue?vue&type=template&id=27e42ac2&"
import script from "./NFCWriter.vue?vue&type=script&lang=js&"
export * from "./NFCWriter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports